import { loadRequestCargaDescarga, loadFailure, loadSuccess } from './actions';
import Swal from 'sweetalert2';
import { select, call, put } from 'redux-saga/effects';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';

export function* loadCargaDescarga({ payload }: ReturnType<typeof loadRequestCargaDescarga>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}dashCargaDescarga&token=${state.auth.token}`,
      {
        dtFim: payload.dtFim,
        dtInicio: payload.dtInicio,
      }
    );

    yield put(loadSuccess(response.data.card, response.data.totais));
  } catch (error: any) {
    put(loadFailure());

    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar so dados, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
